export default __webpack_public_path__ + "static/countdown_anniversary-2be0c8ba9194cc47204bc4e99da8d0d4.png";